import { Create, ListButton, TopToolbar } from 'react-admin';

import ChevronLeft from '@material-ui/icons/ChevronLeft';

import AssetTypeForm from './AssetTypeForm';

const AssetTypeActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const AssetTypeCreate = (props: any) => {
  return (
    <Create actions={<AssetTypeActions {...props} />} {...props}>
      <AssetTypeForm />
    </Create>
  );
};

export default AssetTypeCreate;
